import { getHashedIndex } from '@lyearn/core/utils/hashCode';

export const LEARNER_PROFILE_COVERS = [
  'linear-gradient(260.3deg, #196ddc 0.13%, #1a2980 83.68%)',
  'linear-gradient(276.78deg, #8d51f0 0%, #5e58d6 59.24%)',
  'linear-gradient(275.28deg, #dd294a -9.05%, #932377 99.46%)',
];

export const getLearnerCoverBackground = (userId: string) => {
  const index = getHashedIndex(userId, LEARNER_PROFILE_COVERS.length);
  return LEARNER_PROFILE_COVERS[index];
};
